import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import axiosInstance from '../utils/axiosInstance';
import '../styles/Pages.css';

// Register required components and plugins
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

function LeadsChart() {
  const [leadsData, setLeadsData] = useState([]);
  const [timeRange, setTimeRange] = useState('30'); // Default to last 30 days
  const [error, setError] = useState(''); // Error state

  useEffect(() => {
    const fetchLeadsData = async () => {
      try {
        const response = await axiosInstance.get(`/leads/stats?days=${timeRange}`);
        setLeadsData(response.data);
        setError(''); // Clear any previous error
      } catch (error) {
        console.error('Failed to fetch leads data:', error);
        setError('Failed to load chart data. Please try again.');
      }
    };

    fetchLeadsData();
  }, [timeRange]);

  const data = {
    labels: leadsData.map((lead) => lead.date),
    datasets: [
      {
        label: 'Leads Over Time',
        data: leadsData.map((lead) => lead.count),
        borderColor: '#003366',
        backgroundColor: 'rgba(0, 51, 102, 0.1)',
        tension: 0.3,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Date',
        },
        grid: {
          display: true,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Number of Leads',
        },
        grid: {
          display: true,
        },
      },
    },
  };

  return (
    <div className="chart-container">
      <h2>Leads Over Time</h2>
      <div className="filter-container">
        <label htmlFor="timeRange">Show data for: </label>
        <select
          id="timeRange"
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
        >
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="90">Last 90 Days</option>
        </select>
      </div>

      {error ? (
        <div className="error-message">{error}</div>
      ) : leadsData.length > 0 ? (
        <div style={{ height: '400px' }}>
          <Line data={data} options={options} />
        </div>
      ) : (
        <p>No leads data available for the selected period.</p>
      )}
    </div>
  );
}

export default LeadsChart;

